<template>
  <div id="app">
    <notifications
      group="notifications"
      position="top right"
    />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
